import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.8 6.667V4.334c0-.934 0-1.4.174-1.757.154-.314.399-.569.7-.728.342-.182.79-.182 1.686-.182h6.08c.896 0 1.344 0 1.686.182.301.16.546.414.7.728C18 2.934 18 3.4 18 4.334v6.333c0 .933 0 1.4-.174 1.757a1.635 1.635 0 0 1-.7.728c-.342.182-.79.182-1.686.182H13.2m-8.64 5h6.08c.896 0 1.344 0 1.686-.182.301-.16.546-.415.7-.728.174-.357.174-.824.174-1.757V9.334c0-.934 0-1.4-.174-1.757a1.635 1.635 0 0 0-.7-.728c-.342-.182-.79-.182-1.686-.182H4.56c-.896 0-1.344 0-1.686.182-.301.16-.546.414-.7.728C2 7.934 2 8.4 2 9.334v6.333c0 .933 0 1.4.174 1.757.154.313.399.568.7.728.342.182.79.182 1.686.182z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }